import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/business-automation/main-hero-bg.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner automation-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Business Process Automation Services
              </h1>
              <span>
                Discover Maximum Operational Efficiency With Business Process
                Automation
              </span>
              <p style={{ marginTop: "10px" }}>
                Redefine your processes, reduce operational costs, and improve
                productivity with TekRevol's Process Automation (BPA) Solutions.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start with a Free Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
